import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ServiceConstants } from '../../../constants';
import { ServiceModel } from 'types';

const { REQUEST_ERROR, REQUEST_PENDING, REQUEST_SUCCESS } = ServiceConstants;

interface ServiceState {
  object: Record<string, { status: string; data?: any }>;
}

const initialState: ServiceState = {
  object: {},
};

export const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {
    start: (state: any, action: PayloadAction<string>) => {
      const id = action.payload;
      state.object[id] = { status: REQUEST_PENDING };
    },
    end: (state: any, action: PayloadAction<ServiceModel>) => {
      const { id, data }: ServiceModel = action.payload;
      state.object[id] = { status: REQUEST_SUCCESS, data: data };
    },
    error: (state: any, action: PayloadAction<ServiceModel>) => {
      const { id, data }: ServiceModel = action.payload;
      state.object[id] = { status: REQUEST_ERROR, data: data };
    },
    reset: (state: any, action: PayloadAction<string>) => {
      const id = action.payload;
      delete state.object[id];
    },
  },
});

export const { end, error, reset, start } = serviceSlice.actions;
export default serviceSlice.reducer;
